export default "__VITE_ASSET__a92c7dd6__"